import useNotificationService from './useNotification'
import Notification from './components/Notification'
import notificationsApi from './notifications.api'

const NotificationService = () => {
  const { notificationData, active, setActive } = useNotificationService()
  if (!active) return null

  const handleCancel = () => {
    if (notificationData.type !== 'ALARM_SITUATION_INCIDENT')
      notificationsApi.setNotificationViewed([notificationData.payload.id])
    setActive(false)
  }

  return notificationData && <Notification notification={notificationData} onCancel={handleCancel} />
}

export default NotificationService
